import { render, staticRenderFns } from "./CardControle.vue?vue&type=template&id=4ab4fff0"
import script from "./CardControle.vue?vue&type=script&lang=ts"
export * from "./CardControle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports